import { Controller, useFormContext } from 'react-hook-form'

import {
  extractLayoutProps,
  FormControl,
} from '@tribeplatform/react-ui-kit/FormControl'

import {
  TimezonePicker,
  TimezonePickerProps,
} from '../common/components/TimezonePicker.js'

import { FormFieldProps } from './typings.js'

export function FormTimezonePicker(
  props: Omit<FormFieldProps<TimezonePickerProps>, 'onChange' | 'value'>,
) {
  const { control } = useFormContext()
  const { name, validation, dropdownPosition } = props
  const { layoutProps } = extractLayoutProps(props)

  return (
    <Controller
      control={control}
      name={name}
      rules={validation}
      render={({ field: { onChange, value } }) => (
        <FormControl.Layout {...layoutProps}>
          <TimezonePicker
            value={value}
            dropdownPosition={dropdownPosition}
            onChange={value => {
              onChange(value)
            }}
          />
        </FormControl.Layout>
      )}
    />
  )
}
